export const campustableApi = {
    heading:[
        {
            head:"Campus ID"
        },
        {
            head:"Campus Name"
        },
        {
            head:"Campus Title"
        },
        {
            head:"Holding No."
        },
        {
            head:"Street"
        },
        {
            head:"Area"
        },
        {
            head:"City"
        },
        {
            head:"State"
        },
        {
            head:"District"
        },
        {
            head:"Phone No."
        },
        {
            head:"Map URL"
        },
        {
            head:"Contact Email"
        },
        {
            head:"Longitude"
        },
        {
            head:"Latitude"
        },
        {
            head:"Action"
        }
    ],
    data:[
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
        {
            
        },
    ]
}